import { Material } from "@/app/entities/Material";
import { withCdn } from "@/app/utils/withCdn";
import { format } from "date-fns";
import { getMaterialImages } from "../helper";
import { cn } from "@/app/utils/cn";
import { PARTNER_LOGO } from "@/app/utils/getPartnerLogo";

interface MaterialGroupItemProps {
  material: Material;
  onClick: () => void;
}


export const MaterialGroupItem = ({
  material,
  onClick,
}: MaterialGroupItemProps) => {
  const images = getMaterialImages(material);
  const thumbnailUrl = images.find((img) =>
    ["png", "jpg", "jpeg"].includes(img.split(".").pop() as string),
  );

  return (
    <li
      className="flex w-full cursor-pointer items-center gap-4 rounded-lg border p-4 shadow-sm shadow-black/10 hover:shadow-black/20"
      onClick={onClick}
    >
      <img
        src={thumbnailUrl ? withCdn(thumbnailUrl) : PARTNER_LOGO}
        alt={material?.name}
        className={cn(
          "h-[50px] w-[50px]",
          !thumbnailUrl && "rounded-xl opacity-80 ",
        )}
      />
      {images?.length > 1 && (
        <span className="text-primary">{`+${images.length - 1}`}</span>
      )}
      <div>
        <h3 className="text-lg font-semibold text-black">{material?.name}</h3>
        <p>
          Liberação:{" "}
          <span className="font-semibold">
            {format(new Date(material.dateLiberation), "dd/MM/yyyy")}
          </span>
        </p>
      </div>
    </li>
  );
};
